import React from "react";
import {useTranslation} from "next-i18next";

/**
 *
 */
type Data = {
    code : string
};

/**
 *
 * @param code
 * @returns {JSX.Element}
 * @constructor
 */
export default function Embed ({ code } : Data) {
    // init
    const { t } = useTranslation();

    // render
    return (
        <>
            {/* Button */}
            <button className="w-auto border-0 bg-transparent text-primary p-0 ms-3 me-3" data-bs-toggle="collapse" data-bs-target="#embedHTML" aria-expanded="false" aria-controls="embedHTML">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                     className="bi bi-chevron-left" viewBox="0 0 16 16">
                    <path fillRule="evenodd"
                          d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                     className="bi bi-chevron-right" viewBox="0 0 16 16">
                    <path fillRule="evenodd"
                          d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                </svg>
                <p className="mt-1 small">{t('embed')}</p>
            </button>

            {/* Collapsed content Embed */}
            <div className="collapse col-12" id="embedHTML">
                <div className="card card-body">
                    <code className="small text-wrap">
                        {code}
                    </code>
                </div>
            </div>
        </>
    );
}